import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import AuthorisationMessage from "./components/authorisation-message";
import {
  USER_RESEARCH_AUTHORISATION_STATUS,
  hasMetMaxNumOfRecordings,
  isUserAuthorisedToRecord,
  shouldRecordPath
} from "./hooks";
import PassiveRecorder from "./components/passive-recorder";
import { getDebugModeUrlParams } from "../../utils/session-replay-debug-mode-portal";
import useExperiments from "../../hooks/useExperiments";
import useWindowPath from "../../hooks/useWindowPath";
import DevTool from "./components/dev-tool-popup";
import useGeneralConfigs from "../../hooks/useGeneralConfigs";
var RecordingStatus = /* @__PURE__ */ ((RecordingStatus2) => {
  RecordingStatus2["INIT"] = "INIT";
  RecordingStatus2["GETTING_AUTHORISATION"] = "GETTING_AUTHORISATION";
  RecordingStatus2["AUTHORISED_TO_RECORD"] = "AUTHORISED_TO_RECORD";
  RecordingStatus2["STARTING_RECORDING"] = "STARTING_RECORDING";
  RecordingStatus2["UPDATING_RECORDING"] = "UPDATING_RECORDING";
  RecordingStatus2["RECORDING"] = "RECORDING";
  RecordingStatus2["NO_AUTHORISATION"] = "NO_AUTHORISATION";
  return RecordingStatus2;
})(RecordingStatus || {});
const debugModeParams = getDebugModeUrlParams();
const SessionReplayUserResearchPortal = (props) => {
  const { internalExperiments } = useExperiments();
  const { relevantExperiments } = internalExperiments;
  const [recordingStatus, setRecordingStatus] = React.useState("INIT" /* INIT */);
  const { uid, btm, skipExperimentAuthorisation } = useGeneralConfigs();
  const { customAuthorisationComponent, enableDevTool } = props;
  const path = useWindowPath();
  const isAuthorisedToRecord = skipExperimentAuthorisation ? USER_RESEARCH_AUTHORISATION_STATUS.AUTHORISED : isUserAuthorisedToRecord(relevantExperiments != null ? relevantExperiments : [], uid);
  const hasTooManyRecordings = hasMetMaxNumOfRecordings(relevantExperiments != null ? relevantExperiments : []);
  const isDebugMode = (debugModeParams == null ? void 0 : debugModeParams.enableDebug) && (debugModeParams == null ? void 0 : debugModeParams.larkGroupId);
  useEffect(() => {
    if (recordingStatus !== "INIT" /* INIT */) {
      return;
    }
    if (isDebugMode || // user is in debug mode
    !isAuthorisedToRecord || // user is not authorised to record
    hasTooManyRecordings || // user has too many recordings for the day
    !(relevantExperiments == null ? void 0 : relevantExperiments.length)) {
      setRecordingStatus("NO_AUTHORISATION" /* NO_AUTHORISATION */);
      return;
    }
    if (isAuthorisedToRecord === USER_RESEARCH_AUTHORISATION_STATUS.AUTHORISED) {
      setRecordingStatus("AUTHORISED_TO_RECORD" /* AUTHORISED_TO_RECORD */);
    }
    if (isAuthorisedToRecord === USER_RESEARCH_AUTHORISATION_STATUS.NOT_AUTHORISED) {
      setRecordingStatus("NO_AUTHORISATION" /* NO_AUTHORISATION */);
      return;
    }
    if (isAuthorisedToRecord === USER_RESEARCH_AUTHORISATION_STATUS.PENDING_AUTHORISATION) {
      setRecordingStatus("GETTING_AUTHORISATION" /* GETTING_AUTHORISATION */);
    }
  }, [isAuthorisedToRecord, hasTooManyRecordings, relevantExperiments]);
  const pathBPoint = btm ? btm == null ? void 0 : btm.getCurrentPageBId(path) : path;
  const isPathWhitelisted = shouldRecordPath(pathBPoint, relevantExperiments != null ? relevantExperiments : []);
  if (recordingStatus === "GETTING_AUTHORISATION" /* GETTING_AUTHORISATION */ && isPathWhitelisted) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      enableDevTool && /* @__PURE__ */ jsx(DevTool, { recordingStatus }),
      /* @__PURE__ */ jsx(
        AuthorisationMessage,
        {
          uid,
          recordingStatus,
          setRecordingStatus,
          customAuthorisationComponent
        }
      )
    ] });
  }
  if (recordingStatus === "AUTHORISED_TO_RECORD" /* AUTHORISED_TO_RECORD */ || recordingStatus === "STARTING_RECORDING" /* STARTING_RECORDING */ || recordingStatus === "UPDATING_RECORDING" /* UPDATING_RECORDING */ || recordingStatus === "RECORDING" /* RECORDING */) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      enableDevTool && /* @__PURE__ */ jsx(DevTool, { recordingStatus }),
      /* @__PURE__ */ jsx(
        PassiveRecorder,
        {
          recordingStatus,
          setRecordingStatus,
          uid
        }
      )
    ] });
  }
  if (recordingStatus === "INIT" /* INIT */ || recordingStatus === "NO_AUTHORISATION" /* NO_AUTHORISATION */) {
    return enableDevTool ? /* @__PURE__ */ jsx(DevTool, { recordingStatus }) : null;
  }
  return enableDevTool ? /* @__PURE__ */ jsx(DevTool, { recordingStatus }) : null;
};
var session_replay_user_research_portal_default = SessionReplayUserResearchPortal;
export {
  RecordingStatus,
  session_replay_user_research_portal_default as default
};
